import { BrowserRouter, Router, Route, Routes, Link} from "react-router-dom";
import './App.css';
import React from "react";
import Contact from "./Contact.js";
import Navbar from './components/Navbar';
import background from "./background.jpg";
import Home from "./components/pages/Home.js";
import StraightHair from "./components/pages/StraightHair.js";
import WavyHair from "./components/pages/WavyHair.js";
import CurlyHair from "./components/pages/CurlyHair.js";
import CoilyHair from "./components/pages/CoilyHair.js";
function App() {
  return (
    <div class = 'banner'>
      <BrowserRouter>
         <Navbar/>
         
             <Routes>
             <Route exact path="/" element={<Home/>}/>
             <Route exact path="/straighthair" element={<StraightHair/>}/>
             <Route exact path="/wavyhair" element={<WavyHair/>}/>
             <Route exact path="/curlyhair" element={<CurlyHair/>}/>
             <Route exact path="/coilyhair" element={<CoilyHair/>}/>
             </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
